import { render, staticRenderFns } from "./StudentNotesNew.vue?vue&type=template&id=8b7fa704&scoped=true&"
import script from "./StudentNotesNew.vue?vue&type=script&lang=js&"
export * from "./StudentNotesNew.vue?vue&type=script&lang=js&"
import style0 from "./StudentNotesNew.vue?vue&type=style&index=0&id=8b7fa704&scoped=true&lang=scss&"
import style1 from "./StudentNotesNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7fa704",
  null
  
)

export default component.exports